import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "./chunks/tslib.es6.js";
import { geometryTypes as e } from "./geometry.js";
import r from "./PopupTemplate.js";
import { symbolTypes as s } from "./symbols.js";
import { JSONSupport as o } from "./core/JSONSupport.js";
import { clone as i } from "./core/lang.js";
import { isSome as p } from "./core/maybe.js";
import { generateUID as l } from "./core/uid.js";
import { property as a } from "./core/accessorSupport/decorators/property.js";
import "./core/accessorSupport/ensureType.js";
import { subclass as u } from "./core/accessorSupport/decorators/subclass.js";
import { fromJSON as y } from "./geometry/support/jsonUtils.js";

var _m;

var n = _m = /*#__PURE__*/function (_o) {
  _inherits(m, _o);

  var _super = _createSuper(m);

  function m() {
    var _this;

    _classCallCheck(this, m);

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(t)), _this.isAggregate = !1, _this.layer = null, _this.popupTemplate = null, _this.sourceLayer = null, Object.defineProperty(_assertThisInitialized(_this), "uid", {
      value: l(),
      configurable: !0
    });
    return _this;
  }

  _createClass(m, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(t, e, r, s) {
      return t && !t.declaredClass ? t : {
        geometry: t,
        symbol: e,
        attributes: r,
        popupTemplate: s
      };
    }
  }, {
    key: "attributes",
    set: function set(t) {
      var e = this._get("attributes");

      e !== t && (this._set("attributes", t), this._notifyLayer("attributes", e, t));
    }
  }, {
    key: "geometry",
    set: function set(t) {
      var e = this._get("geometry");

      e !== t && (this._set("geometry", t), this._notifyLayer("geometry", e, t));
    }
  }, {
    key: "symbol",
    set: function set(t) {
      var e = this._get("symbol");

      e !== t && (this._set("symbol", t), this._notifyLayer("symbol", e, t));
    }
  }, {
    key: "visible",
    set: function set(t) {
      var e = this._get("visible");

      e !== t && (this._set("visible", t), this._notifyLayer("visible", e, t));
    }
  }, {
    key: "getEffectivePopupTemplate",
    value: function getEffectivePopupTemplate() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      if (this.popupTemplate) return this.popupTemplate;

      for (var _i = 0, _arr = [this.sourceLayer, this.layer]; _i < _arr.length; _i++) {
        var _e = _arr[_i];

        if (_e) {
          if ("popupTemplate" in _e && _e.popupTemplate) return _e.popupTemplate;
          if (t && "defaultPopupTemplate" in _e && p(_e.defaultPopupTemplate)) return _e.defaultPopupTemplate;
        }
      }

      return null;
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(t) {
      return this.attributes && this.attributes[t];
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(t, e) {
      if (this.attributes) {
        var _r = this.getAttribute(t);

        this.attributes[t] = e, this._notifyLayer("attributes", _r, e, t);
      } else this.attributes = _defineProperty({}, t, e), this._notifyLayer("attributes", void 0, e, t);
    }
  }, {
    key: "getObjectId",
    value: function getObjectId() {
      return this.sourceLayer && "objectIdField" in this.sourceLayer && this.sourceLayer.objectIdField ? this.getAttribute(this.sourceLayer.objectIdField) : null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        geometry: p(this.geometry) ? this.geometry.toJSON() : null,
        symbol: p(this.symbol) ? this.symbol.toJSON() : null,
        attributes: _objectSpread({}, this.attributes),
        popupTemplate: this.popupTemplate && this.popupTemplate.toJSON()
      };
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _m(this.cloneProperties());
    }
  }, {
    key: "notifyGeometryChanged",
    value: function notifyGeometryChanged() {
      this._notifyLayer("geometry", this.geometry, this.geometry);
    }
  }, {
    key: "cloneProperties",
    value: function cloneProperties() {
      return {
        attributes: i(this.attributes),
        geometry: i(this.geometry),
        layer: this.layer,
        popupTemplate: this.popupTemplate && this.popupTemplate.clone(),
        sourceLayer: this.sourceLayer,
        symbol: i(this.symbol),
        visible: this.visible
      };
    }
  }, {
    key: "_notifyLayer",
    value: function _notifyLayer(t, e, r, s) {
      if (!this.layer || !("graphicChanged" in this.layer)) return;
      var o = {
        graphic: this,
        property: t,
        oldValue: e,
        newValue: r
      };
      "attributes" === t && (o.attributeName = s), this.layer.graphicChanged(o);
    }
  }]);

  return m;
}(o);

t([a({
  value: null
})], n.prototype, "attributes", null), t([a({
  value: null,
  types: e,
  json: {
    read: y
  }
})], n.prototype, "geometry", null), t([a({
  type: Boolean
})], n.prototype, "isAggregate", void 0), t([a()], n.prototype, "layer", void 0), t([a({
  type: r
})], n.prototype, "popupTemplate", void 0), t([a()], n.prototype, "sourceLayer", void 0), t([a({
  value: null,
  types: s
})], n.prototype, "symbol", null), t([a({
  type: Boolean,
  value: !0
})], n.prototype, "visible", null), n = _m = t([u("esri.Graphic")], n), function (t) {
  t.generateUID = l;
}(n || (n = {}));
var h = n;
export { h as default };